// @/router/index.ts
import { ElMessageBox } from 'element-plus';
import { createRouter, createWebHistory,createWebHashHistory } from 'vue-router';

const routes = [

    {
        path: '/',
        name: 'home',
        component: () => import('../views/home/index.vue'),
        meta: {
            title: '首页',
            layout: true,
        },
    },
    {
        path: '/login',
        name: 'login',
        component: () => import('../views/login/index.vue'),
        meta: {
            title: '登录',
            layout: true,
        },
    },
];

const router = createRouter({
    history: createWebHashHistory(),
    routes,
});

// router.beforeEach( (to, from,next) => {
//     console.log('vvvv',to,from)
  
//     if(from.path == '/'&&to.path!= '/login'){
//     setTimeout(() => {
//       ElMessageBox({
//             title: '提示',
//             message: `
//               <div style="min-height: 50px; line-height: 22px;">
//               <i class="el-icon-warning" style="color: rgb(90, 164, 255); font-size: 20px; vertical-align: middle;"></i>
//               <span style="color: rgb(48, 49, 51);">您在页面编辑了未保存，是否确认离开</span>
//             </div>
//             `,
//             showCancelButton: true,
//             dangerouslyUseHTMLString: true,
//             // type: 'warning',
//             confirmButtonText: '确定',
//             cancelButtonText: '取消'
//           })
//            .then(() => {
//               // 正常跳转
//               next()
//             })
//             .catch(() => {
//               // 如果取消跳转地址栏会变化，这时保持地址栏不变
//               next()
//             })
  
//     },3000)
//   }else{
//     next()
//   }
  
  
//    })

export default router;
